import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=dd5ee33a&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=dd5ee33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5ee33a",
  null
  
)

export default component.exports